import React from "react";
import { useTranslation } from "react-i18next";

export default function ProductionLineSection() {
    const { t } = useTranslation();

    return (
        <section className="relative py-16 bg-gray-50">
            <div className="container mx-auto px-4">
                <div className="flex flex-col items-center gap-8">
                    <div className="w-full">
                        <h2 className="text-4xl font-bold text-[#E56820] border-b-4 border-[#E56820] w-fit mb-6">
                            {t("Production Line")}
                        </h2>
                        <div className="bg-white shadow-lg rounded-lg p-6 text-lg leading-relaxed">
                            <p className="mt-4">{t("production_line")}</p>
                        </div>
                    </div>
                    <div className="w-full">
                        <img
                            src={require("../../assets/company/linr.JPG")}
                            alt={t("production_line_image")}
                            className="w-full h-[45rem] object-cover rounded-lg shadow-lg transform transition-transform duration-300"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
